<template>
	<div
		style="height: 100vh; overflow-y: auto;"
		:style="{ 'background-color': this.$vuetify.theme.isDark ? '' : '#f5f6fa' }"
	>
		<v-container>
			<v-row justify="center" style="height: 80vh">
				<v-col cols="12" sm="7" lg="6" xl="4">
					<v-card>
						<v-card-title>
							<v-row align="center">
								<v-col class="text-left">
									Buzón
								</v-col>
								<v-col cols="12" sm="8">
									<v-text-field
										v-model="search"
										append-icon="mdi-magnify"
										label="Buscar"
										single-line
										hide-details
									/>
								</v-col>
							</v-row>
						</v-card-title>
						<v-data-table
							mobile-breakpoint="300"
							dense
							:headers="headers"
							:search="search"
							:items="items"
							no-data-text="Vacio"
							:items-per-page="8"
							class="elevation-1"
							@click:row="setItem"
						>
							<template v-slot:[`item.status`]="{ item }">
								<v-chip :color="getColors(item.status)" small dark>
									{{ item.status }}
								</v-chip>
							</template>
						</v-data-table>
					</v-card>
				</v-col>
				<v-col cols="12" sm="5" lg="6" xl="4">
					<v-card v-if="selected" :loading="loadingUpdate || loadingDelete">
						<v-card-title>
							<v-row justify="space-between">
								<v-col cols="9" class="text-left">
									<div>{{ selected.sender }}</div>
									<small class="caption text--secondary">
										{{ `creado el ${selected.updatedAt}` }}
									</small>
								</v-col>
								<v-col class="text-right">
									{{ selected.status }}
									<v-icon right :color="getColors(selected.status)">
										mdi-brightness-1
									</v-icon>
								</v-col>
							</v-row>
						</v-card-title>
						<v-card-text>
							<v-select
								:disabled="selected.status === 'close'"
								label="Asignar"
								filled
								:items="assigneeItems"
								v-model="selected.assignee"
								@change="assignee"
							></v-select>
							<v-textarea
								disabled
								v-model="selected.description"
								label="Detalle"
								filled
							/>
						</v-card-text>
						<v-card-text v-if="selected.resolve">
							<v-textarea
								disabled
								v-model="selected.resolve"
								label="Solucion:"
								filled
							/>
						</v-card-text>
						<v-card-actions>
							<v-btn
								color="accent"
								small
								:loading="loadingDelete"
								@click="deleteMailbox"
							>
								Eliminar
							</v-btn>
							<v-spacer></v-spacer>
							<v-menu
								v-if="selected.status === 'active'"
								v-model="menu"
								:close-on-content-click="false"
								:nudge-width="200"
								offset-x
							>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										text
										class="text-capitalize text-decoration-underline"
										v-bind="attrs"
										v-on="on"
									>
										Marcar como resuelto
									</v-btn>
								</template>
								<v-card>
									<v-card-text>
										<v-textarea v-model="resolve" label="Solucion" filled />
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
											color="primary"
											@click="resolveItem"
											:loading="loadingUpdate"
										>
											Marcar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-menu>
							<v-btn
								v-else
								text
								class="text-capitalize text-decoration-underline"
								@click="resolveItem"
							>
								Marcar como activo
							</v-btn>
						</v-card-actions>
					</v-card>
					<empty
						v-else
						height="130"
						title="Vacio"
						msj="Seleccione un elemento de la izquierda"
					/>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'Support',
	components: {
		Empty: () => import('@/components/ui/DataEmpty'),
	},
	computed: {
		...mapGetters({
			items: 'Mailbox/getMailBoxes',
		}),
	},
	data() {
		return {
			loadingDelete: false,
			loadingUpdate: false,
			menu: false,
			resolve: '',
			search: '',
			headers: [
				{
					text: 'Remitente',
					align: 'start',
					sortable: false,
					value: 'sender',
				},
				{ text: 'Correo', value: 'email' },
				{ text: 'Fecha', value: 'createdAt' },
				{ text: 'Estado', value: 'status' },
			],
			assigneeItems: ['Sin asignar', 'Jesus G.', 'Javier C.', 'Mauro A.', 'Maria P.'],
			selected: null,
		};
	},
	mounted() {
		this.getMailbox();
	},
	methods: {
		setItem(item) {
			this.selected = item;
		},
		getColors(status) {
			switch (status) {
				case 'active':
					return 'success';
				case 'close':
					return 'error';
				default:
					break;
			}
		},
		async resolveItem() {
			this.loadingUpdate = true;
			const status = this.selected.status === 'active' ? 'close' : 'active';
			const resolve = this.selected.status === 'active' ? this.resolve : '';
			const mailbox = await this.update({ ...this.selected, status, resolve });
			this.setItem(mailbox);
			this.resolve = '';
			this.menu = false;
			this.loadingUpdate = false;
		},
		async assignee(assignee) {
			this.loadingUpdate = true;
			const mailbox = await this.update({ ...this.selected, assignee });
			this.setItem(mailbox);
			this.loadingUpdate = false;
		},
		async deleteMailbox() {
			this.loadingDelete = true;
			await this.deleteOne(this.selected._id);
			this.setItem(null);
			this.loadingDelete = false;
		},
		...mapActions({
			getMailbox: 'Mailbox/getMailbox',
			update: 'Mailbox/update',
			deleteOne: 'Mailbox/deleteOne',
		}),
	},
};
</script>
